"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpful_merge_1 = require("helpful-merge");
var rxjs_1 = require("rxjs");
var Store = /** @class */ (function () {
    function Store(state, config, initialValue) {
        if (initialValue === void 0) { initialValue = {}; }
        this.config = config;
        this.state = state;
        this.name = this.config.name;
        this.Model = this.config.model;
        var initialState = helpful_merge_1.default
            .to(new this.Model())
            .from(initialValue)
            .with({
            deep: this.config.containsNestedProps,
            useReferenceIfTargetUnset: true
        })
            .exec();
        this.state.snapshot[this.name] = Object.freeze(initialState);
        this.proxy = this.createStoreProxy(this.value);
        this.actions = this.createStoreActions(this.proxy, this.config.actions);
        this.update$ = this.config.emitOnSubscription ? new rxjs_1.BehaviorSubject(this.value) : new rxjs_1.Subject();
    }
    Object.defineProperty(Store.prototype, "value", {
        get: function () {
            return this.state.snapshot[this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "isActioning", {
        get: function () {
            return !Object.isFrozen(this.value);
        },
        enumerable: true,
        configurable: true
    });
    Store.prototype.readPropertyValue = function (key) {
        return this.value[key];
    };
    Store.prototype.updatePropertyValue = function (key, nextValue) {
        this.value[key] = nextValue;
    };
    Store.prototype.createStoreProxy = function (value) {
        var proxy = Object.seal(this
            .getPropertyDescriptorsFromValue(value)
            .reduce(function (localProxy, _a) {
            var key = _a.key, get = _a.get, set = _a.set;
            return Object.defineProperty(localProxy, key, {
                enumerable: true,
                get: get,
                set: set
            });
        }, {}));
        return proxy;
    };
    Store.prototype.getPropertyDescriptorsFromValue = function (value) {
        var _this = this;
        var prototype = Object.getPrototypeOf(value);
        var allKeys = Object.keys(value).concat(Object.getOwnPropertyNames(prototype));
        return allKeys
            .reduce(function (localDescriptors, key) {
            var propertyDescriptor = Object.getOwnPropertyDescriptor(value, key) ||
                Object.getOwnPropertyDescriptor(prototype, key);
            if (key !== 'constructor') {
                var isAccessorProperty = typeof propertyDescriptor.get === 'function';
                localDescriptors.push({
                    get: _this.readPropertyValue.bind(_this, key),
                    set: isAccessorProperty ? void 0 : _this.updatePropertyValue.bind(_this, key),
                    key: key
                });
            }
            return localDescriptors;
        }, []);
    };
    Store.prototype.createStoreActions = function (proxy, actionsResolver) {
        var _this = this;
        var actions = {};
        var consumerActions = actionsResolver(proxy, actions);
        return Object
            .keys(consumerActions)
            .reduce(function (localActions, key) {
            localActions[key] = _this.createActionProxy(consumerActions[key]);
            return localActions;
        }, actions);
    };
    Store.prototype.createActionProxy = function (action) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.state.isTraversing)
                return;
            var wasGlobalInstigator = false;
            var wasLocalInstigator = false;
            if (!_this.state.isActioning) {
                wasGlobalInstigator = true;
                _this.state.pushNextSnapshotToHistory(__assign({}, _this.state.snapshot));
            }
            if (!_this.isActioning) {
                wasLocalInstigator = true;
                _this.state.snapshot[_this.name] = helpful_merge_1.default
                    .to(new _this.Model())
                    .from(_this.value)
                    .with({
                    deep: _this.config.containsNestedProps,
                    useReferenceIfTargetUnset: true
                })
                    .exec();
            }
            action.apply(_this.actions, args);
            if (wasLocalInstigator) {
                Object.freeze(_this.value);
                _this.update$.next(_this.value);
            }
            if (wasGlobalInstigator) {
                Object.freeze(_this.state.snapshot);
                _this.state.update$.next(_this.state.snapshot);
                if (_this.state.config.debug) {
                    console.info("Store \"" + _this.name + "\" updated by action `" + action.name + "()`");
                }
            }
        };
    };
    return Store;
}());
exports.default = Store;
//# sourceMappingURL=Store.js.map